import React, { useState, useEffect, useMemo } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { ParseHtml } from "../../../utils/parseHtml";
import { FormLoader } from "../../../utils/Loader";
import evalStyle from "../../../assets/css/modules/evalhistory.module.css";

const EvaluationScreen = ({
  isFetching,
  toggleModal,
  activityHistoryAllInfo,
}) => {
  /* ---------- loading guard ---------- */
  if (isFetching) {
    return (
      <div className="text-center">
        <FormLoader width={800} />
      </div>
    );
  }

  if (!activityHistoryAllInfo) {
    return <div className="p-3 text-center">No data available</div>;
  }
  const {
    evalsummaryDetails = {},
    myevalautionsForms = [],
    formid,
  } = activityHistoryAllInfo;
  if (!evalsummaryDetails) {
    return (
      <div className="p-3 text-center">No evaluation summary available</div>
    );
  }
  const {
    dataLabels = [],
    questionAnswers = [],
    additinalnotes = [],
  } = evalsummaryDetails || {};
  const currentForm = myevalautionsForms?.find((f) => f.formid === formid);

  const isAverage = currentForm?.formscoringtype?.toLowerCase() === "average";

  const orderedLabels = [...dataLabels].sort(
    (a, b) => (a.sortorder ?? 0) - (b.sortorder ?? 0),
  );
  const sortedAdditinalnotes = [...(additinalnotes || [])].sort(
    (a, b) => a.sortorder - b.sortorder,
  );

  const closeBtn = (
    <div className="links_right w-45">
      <button className="modal_close" onClick={toggleModal} type="button">
        <img title="Attached File" src="images/close.svg" />
      </button>
    </div>
  );
  return (
    <div id="eval_history_details">
      <ModalHeader
        toggle={toggleModal}
        close={closeBtn}
        className="custom-modal metric_header"
      >
        <div className="d-flex flex-start align-center">
          <div className="title">QA Form History</div>
        </div>
      </ModalHeader>
      <ModalBody id="" style={{ maxHeight: "80vh", overflowY: "auto" }}>
        <div className="row">
          {orderedLabels?.map((dataLable, index) => (
            <div className="col-md-3" key={index}>
              <div className="form-group">
                <label>{dataLable.lablename}</label>
                <div
                  key={dataLable.lablename + index}
                  className="form-control"
                  contentEditable="false"
                  style={
                    dataLable.labeltype?.toLowerCase() == "richtext"
                      ? {
                          maxHeight: "100%",
                          whiteSpace: "normal",
                          width: "100%",
                          display: "flex",
                          flexWrap: "wrap",
                          wordBreak: "break-word",
                        }
                      : {}
                  }
                >
                  {ParseHtml(dataLable.lablevalue)}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="row">
          <div className="col-md-12">
            {questionAnswers?.map((category, index) => {
              const sortedQuestions = [...(category.questions || [])].sort(
                (a, b) => a.sortorder - b.sortorder,
              );

              return (
                <div
                  className={evalStyle.categories_questionsandans}
                  key={`qa-${index}`}
                >
                  <div className="card">
                    <div className={evalStyle["card-header"]}>
                      <h3>{category.category}</h3>
                    </div>
                    {sortedQuestions?.map((question, qIndex) => {
                      return (
                        <div className="card-body" key={`q-${qIndex}`}>
                          <div className={evalStyle.question_block}>
                            <div className={evalStyle.questionn}>
                              {question.ishtml
                                ? ParseHtml(question.questionname)
                                : question.questionname}
                            </div>
                            <div
                              className={`${evalStyle.answerr} ${evalStyle.defaultt_color} `}
                            >
                              {question.answer}
                            </div>
                            <div className="d-flex space-between align-center">
                              <div
                                className={`${evalStyle["w-100"]} ${evalStyle["mr-5"]}`}
                              >
                                <textarea
                                  className="form-control"
                                  rows="3"
                                  cols="10"
                                  readOnly
                                >
                                  {/* bool showNotes = false;


                                  if (loggedInUserEmail.StartsWith("amplifai.", StringComparison.OrdinalIgnoreCase))
                                  {
                                    showNotes = true;
}
                                  else if (!string.IsNullOrEmpty(roleConfigValue))
                                  {
                                    showNotes = true; */}

                                  {/* {question.notes}  to hide the block when logged in with that particular user*/}
                                </textarea>
                              </div>
                              <div className={evalStyle["points"]}>
                                {isAverage ? (
                                  <span>
                                    {Number(question.score).toFixed(2)}
                                  </span>
                                ) : (
                                  <>
                                    <span>
                                      {Number(question.score).toFixed(2)}
                                    </span>
                                    <span> out of </span>
                                    <span>
                                      {Number(question.maxpoints).toFixed(2)}
                                    </span>
                                    <span></span>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="row">
          <div className={evalStyle.categories_questionsandans}>
            <div className="col-md-12 px-0">
              <div className="card">
                <div className={evalStyle["card-header"]}>
                  <h3>Additional Notes</h3>
                </div>
                {sortedAdditinalnotes?.map((note, noteIndex) => (
                  <div className="card-body" key={`note-${noteIndex}`}>
                    <label>{note.noteslable}</label>
                    <textarea
                      className="form-control"
                      rows="5"
                      cols="10"
                      readOnly
                    >
                      {note.notesanswer}
                    </textarea>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* <div className="row" id="AckEvalBlockShow">
          <div className="col-md-12">
            <div className="form-group">
              <label>Acknowledgement Notes</label>
              <textarea
                spellCheck="true"
                rows="5"
                id="acknowledgement"
                placeholder="Please add your comments regarding this interaction"
                className={`form-control child acknowledgement `}
              ></textarea>
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-check"></div>
          </div>
        </div> */}
      </ModalBody>
    </div>
  );
};

export default EvaluationScreen;
